import { useContext, useState, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { PublicCasesQuery } from 'interfaceAdapter/queries/PublicCases';
import { IPublicAgent } from 'domain/entities/Agent/Agent';

export const useCases = () => {
    const diContainer = useContext(diContainerContext);
    const publicCasesQuery = diContainer.resolve(PublicCasesQuery);
    const [agents, setAgents] = useState<IPublicAgent[]>([]);
    const [matchCount, setMatchCount] = useState<number>(0);

    useEffect(() => {
        const fetchData = async () => {
            const res = await publicCasesQuery.fetch();
            setAgents(res.agents.slice(0, 5));
            setMatchCount(res.match_count);
        };
        fetchData();
    }, []);

    return {
        agents,
        matchCount,
    };
};
